import React from "react";
import PercentileBox from "./PercentileBox";
import "./index.scss";

export default function DomainThreadScore(props) {
  const { title, data } = props;

  return (
    <div className="domain-thread-card" onClick={props.onClick} 
    // {...props}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
    onFocus={props.onFocus}
    >
      <div className="dt-card-inset hover-opacity">
        <div className="dt-title">{title}</div>
        <PercentileBox
          mastery={data.mastery}
          mode="domain"
          boxStyle={{ width: 64, marginLeft: 10 }}
          textStyle={{ fontSize: 28, fontWeight: "600" }}
        />
      </div>
    </div>
  );
}
